import { createSlice } from "@reduxjs/toolkit";

const animationSlice = createSlice({
  name: "animation",
  initialState: {
    animationShown: false,
    animationFinished: false,
  },
  reducers: {
    showAnimation(state) {
      state.animationShown = true;
      state.animationFinished = false;
    },
    hideAnimation(state) {
      state.animationShown = false;
    },
    finishAnimation(state) {
      state.animationFinished = true;
    },
  },
});

export const { showAnimation, hideAnimation, finishAnimation } =
  animationSlice.actions;
export default animationSlice.reducer;
